<template>
  <wx-swiper class="banners-mp-swiper" :kbone-attribute-map="config">
    <wx-swiper-item v-for="(bannerItem, index) in bannerListData" :key="index">
      <BannerImage
        :banner-index="index"
        :bannerData="bannerItem"
        :bannerType="bannerType"
        :isMultBrow="isMultBrow"
        @click.native="onClick(bannerItem)"
      />
    </wx-swiper-item>
  </wx-swiper>
</template>

<script lang="ts">
import { BannerConfig, BannerType } from '../../types';
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import BannerImage from '../banner-image.vue';


/** 适用于小程序内Swiper场景 */
@Component({
  components: {
    BannerImage,
  },
})
export default class MpSwiper extends Vue {
  /** banner数据 */
  @Prop({ default: [] }) bannerListData!: BannerConfig[];
  /** swiper配置项 */
  @Prop({ default: () => ({}) }) swiperOptions!: any;
  /** 是否支持重复曝光上报 */
  @Prop({ default: true }) isMultBrow!: Boolean;
  /** 在template中使用 */
  bannerType = BannerType.mpSwiper;
  /**
   * 小程序swiper配置，参考
   * https://developers.weixin.qq.com/miniprogram/dev/component/swiper.html
   */
  get config() {
    return {
      'indicator-dots': this.bannerListData.length > 1,
      'indicator-active-color': '#07C160',
      autoplay: true,
      interval: 3000,
      ...this.swiperOptions,
    };
  }

  @Emit('click')
  onClick(bannerItem: BannerConfig) {
    return bannerItem;
  }
}
</script>

<style lang="less">
@import (reference) url(../../less/index.less);
.banners-mp-swiper {
  height: 176 / @rem;
  margin: 0 32 / @rem;
  border-radius: 8 / @rem;
  overflow: hidden;
  transform: translateY(0);
  .banner-image {
    height: 176 / @rem;
    width: 100%;
  }
}
</style>
